import { render, staticRenderFns } from "./ItemsRentCreate.vue?vue&type=template&id=2cedef38&scoped=true&"
import script from "./ItemsRentCreate.vue?vue&type=script&lang=js&"
export * from "./ItemsRentCreate.vue?vue&type=script&lang=js&"
import style0 from "./ItemsRentCreate.vue?vue&type=style&index=0&id=2cedef38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cedef38",
  null
  
)

export default component.exports